"use client"

import { Languages } from 'lucide-react'
import { cn } from '@/lib/utils'
import { LANGS, LANG_NAMES, setLang, useLang, useT } from '@/lib/i18n'

/**
 * The interface language of THIS device (phase A, 2026-09-29): a cashier may
 * sell in Russian at a till where the owner reads Georgian on his phone. It
 * sits where every role can reach it — a cashier cannot open Settings. Each
 * language is written in itself, so it is found by someone who cannot read
 * the one on screen.
 */
export function LanguageSwitch({ collapsed }: { collapsed: boolean }) {
  const t = useT()
  const lang = useLang()
  if (collapsed) {
    const next = LANGS[(LANGS.indexOf(lang) + 1) % LANGS.length]
    return (
      <button
        type="button"
        onClick={() => void setLang(next)}
        title={`${t('common.language')}: ${LANG_NAMES[next]}`}
        className="size-10 rounded-xl border border-border text-muted-foreground hover:text-foreground hover:bg-muted flex items-center justify-center gap-0.5 transition-colors"
      >
        <Languages className="size-3.5" />
        <span className="text-[12px] font-black uppercase">{lang}</span>
      </button>
    )
  }
  return (
    <div className="flex items-center gap-2">
      <Languages className="size-4 text-muted-foreground shrink-0" aria-hidden />
      <div role="radiogroup" aria-label={t('common.language')} className="flex-1 flex p-0.5 rounded-xl bg-muted/60 border border-border">
        {LANGS.map((l) => (
          <button
            key={l}
            type="button"
            role="radio"
            aria-checked={lang === l}
            lang={l}
            onClick={() => void setLang(l)}
            className={cn(
              'flex-1 h-7 rounded-lg text-[12px] font-bold transition-colors',
              lang === l ? 'bg-card dark:bg-white/10 text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {LANG_NAMES[l]}
          </button>
        ))}
      </div>
    </div>
  )
}
